<script>

    import { toast } from 'bulma-toast'
    import { modalStore, shopifysStore } from '../stores'
    
    import ShopifyService from '../$services/shopify.service'
    import TranslateMethods from '../$methods/translate.methods'

    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    let loading = false
    let query = {
        admin: true
    }

    getShopifyApps()

    async function getShopifyApps() {

        loading = true
        const resp = await ShopifyService.getShopifyApps(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        shopifysStore.set(resp.data)
    }

</script>

<Table items={ $shopifysStore.length } { loading }>
    <thead>
        <tr>
            <th>#</th>
            <th>Estatus</th>
            <th>Usuario</th>
            <th>Dominio</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $shopifysStore as shopify, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ TranslateMethods.get(shopify.status) }</td>
                <td>
                    <div>
                        <span>{ shopify.user && shopify.user.name }</span>
                        <span>{ shopify.user && shopify.user.email }</span>
                    </div>
                </td>
                <td>{ shopify.domain }</td>
                <td class="has-text-right">
                    <Button on:click={() => modalStore.open('shopify', 'update_modal', shopify)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>